import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAspectRatioPortrait = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 18,
	viewBox: "0 0 14 18",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M14 15.333C14 16.8057 12.7465 17.9999 11.2002 18H2.7998C1.2535 17.9999 0 16.8057 0 15.333V2.66699C0 1.19429 1.2535 0.0001 2.7998 0H11.2002C12.7465 0.0001 14 1.19429 14 2.66699V15.333ZM6.2988 2.66699C6.2988 2.29886 5.9851 2.0001 5.5986 2H2.79883C2.41223 2 2.09863 2.2988 2.09863 2.66699V6.66699C2.09882 7.035 2.41234 7.333 2.79883 7.333C3.18513 7.3328 3.49786 7.0349 3.49805 6.66699V5.33301C3.49823 4.22859 4.43895 3.33301 5.5986 3.33301C5.985 3.33291 6.2986 3.03497 6.2988 2.66699ZM11.8984 11C11.8984 10.6318 11.5848 10.333 11.1982 10.333C10.8117 10.3331 10.498 10.6319 10.498 11V13C10.498 13.9205 9.7145 14.667 8.748 14.667C8.3617 14.6672 8.049 14.9651 8.0488 15.333C8.0488 15.7011 8.3616 15.9998 8.748 16H11.1982C11.5848 16 11.8984 15.7012 11.8984 15.333V11Z",
		fill: "#545F7E"
	})]
});
const ForwardRef = forwardRef(SvgAspectRatioPortrait);
export default ForwardRef;
